import { render, staticRenderFns } from "./regProfile.vue?vue&type=template&id=3c29e78c&scoped=true&"
import script from "./regProfile.vue?vue&type=script&lang=js&"
export * from "./regProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29e78c",
  null
  
)

export default component.exports